/* =================================
		BACK TO TOP
==================================== */
window.requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame || function(timeOutFn){return setTimeout(timeOutFn, 1000 / 60);};
window['prism2412'] = function(){
  if(typeof jQuery == 'function' && !document.getElementsByClassName('running2412').length && document.getElementsByClassName('header-wrap').length){
    document.body.classList.add('running2412');
    applychanges2412();
    jQuery(window).scroll(function(){
      if(jQuery(window).scrollTop() > 100){
        jQuery('.scrollToTopArrow').stop(true).fadeIn();
      }else{
        jQuery('.scrollToTopArrow').stop(true).fadeOut();
      }
    });
    jQuery(window).scroll();
    console.log('Main Function Running. (running2412)');
  }else if(!document.getElementsByClassName('running2412').length){
    window.requestAnimationFrame(prism2412);
  }
}; 
prism2412();
function applychanges2412(){
  var smallinit = setInterval(function(){
    if(!jQuery('.scrollToTopArrow').length){
      jQuery('body').append('<div class="scrollToTopArrow">Top</div>'); 
      jQuery(document).on('click', '.scrollToTopArrow', function(){
        jQuery('body, html').animate({scrollTop:'0'}, 600);
      });
      clearInterval(smallinit);      
    } else {
      setTimeout(function(){
        clearInterval(smallinit);
      },5000);
    }    
  },100);
}
/* =============================================
  		STOCK INDICATOR AND POPOVER
================================================ */
function isTouchScreendevice() {
  let isMobile = window.matchMedia(
    "only screen and (max-width: 760px)"
  ).matches;

  if (isMobile) {
    return "ontouchstart" in window || navigator.maxTouchPoints;
  }
}

if (isTouchScreendevice()) {
  $(".main-content").addClass("touch");
  $(".main-content").removeClass("notouch");
  $(".tooltip .open").click(function () {
    $(".tooltip").removeClass("active");
    $(this).parent(".tooltip").toggleClass("active");
    $(this).parent().parent(".tooltip").toggleClass("active");
    $(".stockclose").addClass("show bgshow");
  });

  $(".tooltiptext .close").click(function () {
    $(".tooltip").removeClass("active");
    $(".stockclose").removeClass("show bgshow");
  });
} else {
  $(".main-content").removeClass("touch");
  $(".main-content").addClass("notouch");
  $(document)
    .on("mouseenter", ".tooltip .open", function (event) {
      $(".tooltip").removeClass("active");
      $(this).parent(".tooltip").toggleClass("active");
      $(this).parent().parent(".tooltip").toggleClass("active");
    })
    .on("mouseleave", ".tooltip .open", function () {
      $(".tooltip").removeClass("active");
    });
}
jQuery( document ).ready(function($) {
    
   $( ".stock-wrap-nov2 .tooltip" ).click(function() {
      $(".stock-wrap-nov2 .classic .popover").addClass("show");
      $(".stockclose").addClass("show");
    });
	$(document).on('mouseenter','.stock-wrap-nov2 .tooltip', function (event) {
        $(".stock-wrap-nov2 .popover").addClass("show");
    }).on('mouseleave','.stock-wrap-nov2 .tooltip',  function(){
        $(".stock-wrap-nov2 .popover").removeClass("show");
    });
  $( ".stockclose" ).click(function() {
    $(".stock-wrap-nov2 .popover").removeClass("show");
    $(".stockclose").removeClass("show");
    $(".stockclose").removeClass("bgshow");
    $(".prodCont").removeClass("show");
  });

  $('.jdgm-preview-badge--with-link').click(function() {
        $('#review-anchor-click')[0].click();
    });
  $(".voucher-wrap .tooltip .open").click(function () {
    $(".stockclose").addClass("bgshow");
  });
});

/* =============================================
  		PRODUCT GROUPSELL
================================================ */
// jQuery( document ).ready(function($) {
//   $('.groupsell-wrap .prodCont').slick({
//       dots: false,
//       infinite: false,
//       arrows:false,
//       slidesToShow: 2,
//       slidesToScroll: 1
//     });
//   $(window).resize(function(){
//     $('.groupsell-wrap .prodCont')[0].slick.refresh();
//   });
//   if ($(window).width() < 1023) {       
//      $( ".groupsell-wrap .infoicon" ).click(function() {
//        	$(".stockclose").addClass("show");
//        	$(".prodCont").addClass("show");
//         $(".stockclose").addClass("bgshow");
//       });
//   }
//   $(document).on('mouseleave','.groupsell-wrap .infoicon',  function(){
//       $(".stockclose").removeClass("show");
//       $(".prodCont").removeClass("show");
//       $(".stockclose").removeClass("bgshow");
//     console.log('remove');
//   });
//   var tempcheckout = $('.product-form__checkout').attr("href");
//   var tempcart = $('.product-form__cart').attr("href");
//   $('.checkout-hdden').val(tempcheckout);
//   $('.cart-hdden').val(tempcart);
//   $(".tickContainer").click(function() {
//     $('.newsalebox2').removeClass('selected');
    
//     var cart = $('.cart-hdden').val();
//     var orig = $('.checkout-hdden').val();
//     if ($(this).prev('input[name="bundle_prod"]').is(":checked")){ // box is checked
//         $(this).prev('input[name="bundle_prod"]').prop("checked", false);
//       	$('.product-form__checkout').attr("href", orig);
//       	$('.product-form__cart').attr("href", cart);
      
//       	$('#ProdBundle').attr("data-vid", "");
//       	$('#ProdBundle').attr("data-vtitle", "");
//       	$('#ProdBundle').attr("data-vprice", "");
      	
//     } else{ // box is not checked
//         $(this).prev('input[name="bundle_prod"]').prop("checked", true);
//       	$(this).parent().closest('.newsalebox2').toggleClass('selected');
      
//       $('.selectedgroupsell').text(jQuery('input[name="bundle_prod"]:checked').val());
//       var selected =  $(this).prev('input[name="bundle_prod"]:checked').val();
//       var GrpId =  $('.newsalebox2.selected input[name="bundle_prod"]:checked').val();
//       var GrpType =  $('.newsalebox2.selected input[name="bundle_prod"]:checked').attr("data-vtype");
//       var GrpTitle =  $('.newsalebox2.selected .prodName2').text();
//       var GrpPrice =  $('.newsalebox2.selected .prodprice2 .newprice').text();
      
//       $('.product-form__checkout').attr("href", orig+","+selected+":1");
//       $('.product-form__cart').attr("href", cart+"&id[]="+selected+"&quantity=1");
      
//       $('#ProdBundle').attr("data-vid", GrpId);
//       $('#ProdBundle').attr("data-vtitle", GrpTitle);
//       $('#ProdBundle').attr("data-vprice", GrpPrice);
//       $('#ProdBundle').attr("data-vtype", GrpType);
//     }	
    
    
//   });

//   $('.product-form__variants2').change(function() { // for tv variants
//     var tvid = this.value;
//     var bundle = $(this).children("option:selected").attr('data-bundled-variant-ids');
//     var orig = $('.product-form__checkout').attr("href");
//     var cart = $('.product-form__cart').attr("href");
// 	var GrpTitle =  $(this).children("option:selected").attr('data-title');
//     var GrpPrice =  $(this).children("option:selected").attr('data-price');

//     if(bundle == undefined){ /* if no bundle is found */
//       	$('.product-form__checkout').attr("href", "https://prismplus.com.au/cart/"+tvid+":1");
//     	$('.product-form__cart').attr("href", "https://prismplus.com.au/cart/add?id[]="+tvid+"&quantity1");

//     }else{
//       	var bundles = bundle.split(',');
//         if(bundles.length > 1){
//           	console.log('one');
//            var chitems = [];
//            var items = [];
//            var ctitems;
//            for (var i = 0; i < bundles.length; i++) {
//              chitems.push(bundles[i]+":1");
//              items.push("&id[]="+bundles[i]+"");
//           }
//           console.log(items.join(""));
//           ctitems = items.join("");
//           $('.product-form__checkout').attr("href", "https://prismplus.com.au/cart/"+tvid+":1,"+chitems);
//           $('.product-form__cart').attr("href", "https://prismplus.com.au/cart/add?id[]="+tvid+ctitems+"&quantity1");
//         }else{
//           $('.product-form__checkout').attr("href", "https://prismplus.com.au/cart/"+tvid+":1,"+bundle+":1");
//           $('.product-form__cart').attr("href", "https://prismplus.com.au/cart/add?id[]="+tvid+"&id[]="+bundle+"&quantity1");
          

//           $('#ProdBundle').attr("data-vid", bundle);
//           $('#ProdBundle').attr("data-vtitle", GrpTitle);
//           $('#ProdBundle').attr("data-vprice", GrpPrice);
//         }
//     }
//   });
// });
/* =============================================
  		PRODUCT GROUPSELL
================================================ */
jQuery(document).ready(function ($) {
  $(".groupsell-wrap .prodCont").slick({
    dots: false,
    infinite: false,
    arrows: false,
    slidesToShow: 2,
    slidesToScroll: 1,
  });
  $(window).resize(function () {
    $(".groupsell-wrap .prodCont")[0]?.slick.refresh();
  });
  if ($(window).width() < 1023) {
    $(".groupsell-wrap .infoicon").click(function () {
      $(".stockclose, .infoicon").addClass("show");
      $(".prodCont").addClass("show");
      $(".stockclose").addClass("bgshow");
    });
  }
  $(document).on("mouseleave", ".groupsell-wrap .infoicon", function () {
    $(".stockclose, .infoicon").removeClass("show");
    $(".prodCont").removeClass("show");
    $(".stockclose").removeClass("bgshow");
    //console.log('remove');
  });
  var tempcheckout = $(".product-form__checkout").attr("href");
  var tempcart = $(".product-form__cart").attr("href");
  $(".checkout-hdden").val(tempcheckout);
  $(".cart-hdden").val(tempcart);

  $(".click-plus").click(function () {
    $(".newsalebox2:has(.click-plus)").removeClass("selected");
    $(".bundled-addon-selectors .addon-box").removeClass("active");
    if($(".bundled-addon-selectors").length){
    //if (location.pathname.indexOf("/prism-monsoon-dryer") > -1) {
      setTimeout(function () {
          $(".bundled-addon-selectors.selected .select-wrapper .addon-box").first().click();
          console.log('selector clicked');
          if ($(".bundled-addon-selectors").hasClass("selected")) {
            $(".selectedgroupsell").text("");        
           };
        }, 300);
        
    }
    var cart = $(".cart-hdden").val();
    var orig = $(".checkout-hdden").val();
    if ($(this).hasClass("clicked")) {
      // box is checked, set to unchecked
      $(this).prev('input[name="bundle_prod"]').prop("checked", false);
      $(this).prev('input[name="bundle_prod"]').trigger("change");
      $(".product-form__checkout").attr("href", orig);
      $(".product-form__cart").attr("href", cart);
      $(".selectedgroupsell").text("");
      $("#ProdBundle").attr("data-vid", "");
      $("#ProdBundle").attr("data-vtitle", "");
      $("#ProdBundle").attr("data-vprice", "");
      $(".click-plus").removeClass("clicked");
      resetBundleInitial();
    } else if ($(this).prev('input[name="bundle_prod"]').is(":checked")) {
      // box is checked, set to unchecked
      $(this).prev('input[name="bundle_prod"]').prop("checked", false);
      $(this).prev('input[name="bundle_prod"]').trigger("change");
      $(".product-form__checkout").attr("href", orig);
      $(".product-form__cart").attr("href", cart);
      $(".selectedgroupsell").text("");
      $("#ProdBundle").attr("data-vid", "");
      $("#ProdBundle").attr("data-vtitle", "");
      $("#ProdBundle").attr("data-vprice", "");
      $(".click-plus").removeClass("clicked");
      resetBundleInitial();
    } else {
      // box is not checked, set to checked
      $(".click-plus").removeClass("clicked");
      $(this).addClass("clicked");
      $(this).prev('input[name="bundle_prod"]').prop("checked", true);
      $(this).parent().closest(".newsalebox2").toggleClass("selected");
      
      /* get current variant */
      var selectedVariant = $("#currentSelection").attr("data-variant");
      /* get current quantity */
      var quantitySel = $("#currentSelection").attr("data-quantity");
      if (quantitySel != "") {
        var quantity = $("#currentSelection").attr("data-quantity");
      } else {
        var quantity = "1";
      }

      $(".selectedgroupsell").text(
        jQuery('input[name="bundle_prod"]:checked').val()
      );
      var selected = $(this).prev('input[name="bundle_prod"]:checked').val();
      var GrpId = $(
        '.newsalebox2.selected input[name="bundle_prod"]:checked'
      ).val();
      var GrpType = $(
        '.newsalebox2.selected input[name="bundle_prod"]:checked'
      ).attr("data-vtype");
      var GrpTitle = $(".newsalebox2.selected .prodName2").text();
      var GrpPrice = $(".newsalebox2.selected .prodprice2 .newprice").text();

      
      
      groupsell_variant_select();
      
      updateLinks();
      $("#ProdBundle").attr("data-vid", GrpId);
      $("#ProdBundle").attr("data-vtitle", GrpTitle);
      $("#ProdBundle").attr("data-vprice", GrpPrice);
      $("#ProdBundle").attr("data-vtype", GrpType);
    }
    
  });

  $(".click-plus-2").click(function () {
    $(".newsalebox2:has(.click-plus-2)").removeClass("selected");

    function updateLinks2(checked, variantId) {
      let selectedVariant = $("#currentSelection").attr("data-variant");
      let quantity = $("#currentSelection").attr("data-quantity");
      let selectedGroupsell = $(".selectedgroupsell").text();
      let checklink = `${selectedVariant}:${quantity}`;
      let cartlink = `${selectedVariant}`;

      if (selectedGroupsell != "") {
        checklink = `${checklink},${selectedGroupsell}:${quantity}`;
        cartlink = `${cartlink}&id[]=${selectedGroupsell}`;
      }

      if (checked) {
        $(".selectedgroupsell-second").text(variantId);
        checklink = `${checklink},${variantId}:1`;
        cartlink = `${cartlink}&id[]=${variantId}`;
      } else {
        $(".selectedgroupsell-second").text("");
      }

      cartlink = `${cartlink}&quantity=${quantity}`;

      $(".product-form__checkout").attr("href", "/cart/" + checklink);

      $(".product-form__cart").attr("href", "/cart/add?id[]=" + cartlink);
    }

    if ($(this).hasClass("clicked")) {
      // box is checked, set to unchecked
      $(this).prev('input[name="bundle_prod_2"]').prop("checked", false);
      $(this).prev('input[name="bundle_prod_2"]').trigger("change");
      $(".click-plus-2").removeClass("clicked");
      updateLinks2(false);
    } else {
      // box is not checked, set to checked
      $(".click-plus-2").removeClass("clicked");
      $(this).addClass("clicked");
      $(this).prev('input[name="bundle_prod_2"]').prop("checked", true);
      $(this).prev('input[name="bundle_prod_2"]').trigger("change");
      $(this).parent().closest(".newsalebox2").toggleClass("selected");
      updateLinks2(true, $(this).prev('input[name="bundle_prod_2"]').val());
    }
  });
  /* end of click for groupsell */

  $(".product-form__variants2").change(function () {
    // for tv variants
    var tvid = this.value;
    var bundle = $(this)
      .children("option:selected")
      .attr("data-bundled-variant-ids");
    var orig = $(".product-form__checkout").attr("href");
    var cart = $(".product-form__cart").attr("href");
    var GrpTitle = $(this).children("option:selected").attr("data-title");
    var GrpPrice = $(this).children("option:selected").attr("data-price");
    var GrpType = $(this).children("option:selected").attr("data-vtype");
    var Groupsell = $(".selectedgroupsell").text();

    if (tvid != "-") {
      $("#currentSelection").attr("data-variant", tvid);
    }

    if (bundle == undefined) {
      /* if no bundle is found */
      $(".product-form__checkout").attr("href", "/cart/" + tvid + ":1");
      $(".product-form__cart").attr(
        "href",
        "/cart/add?id[]=" + tvid + "&quantity1"
      );
    } else {
      var bundles = bundle.split(",");
      if (bundles.length > 1) {
        var chitems = [];
        var items = [];
        var ctitems;
        for (var i = 0; i < bundles.length; i++) {
          chitems.push(bundles[i] + ":1");
          items.push("&id[]=" + bundles[i] + "");
        }
        //items.push("&id[]="+Groupsell+"");
        //console.log(items.join(""));
        ctitems = items.join("");
        $(".product-form__checkout").attr(
          "href",
          "/cart/" + tvid + ":1," + chitems
        );
        $(".product-form__cart").attr(
          "href",
          "/cart/add?id[]=" + tvid + ctitems + "&quantity1"
        );
      } else {
        $(".product-form__checkout").attr(
          "href",
          "/cart/" + tvid + ":1," + bundle + ":1"
        );
        $(".product-form__cart").attr(
          "href",
          "/cart/add?id[]=" + tvid + "&id[]=" + bundle + "&quantity1"
        );

        $("#ProdBundle").attr("data-vid", bundle);
        $("#ProdBundle").attr("data-vtitle", GrpTitle);
        $("#ProdBundle").attr("data-vprice", GrpPrice);
        $("#ProdBundle").attr("data-vtype", GrpType);
      }
    }
  });

  /* =========================
  Consolidated function to update add to cart and buy now links
  - the links includes groupsell and quantity options
  ============================ */

  /* Quantity selector */
  /* quantity add to cart */
  //$('#aura-qty').val("5");
  var input = $("#aura-qty"),
    minValue = parseInt(input.attr("min"));

  $(".qty-increase").on("click", function () {
    var inputValue = input.val();
    var newInput = input.val(parseInt(inputValue) + 1);
    input.val(parseInt(inputValue) + 1);
    $("#currentSelection").attr("data-quantity", newInput.val());
    updateLinks();
  });
  $(".qty-decrease").on("click", function () {
    var inputValue = input.val();
    if (inputValue >= 2) {
      input.val(parseInt(inputValue) - 1);
      var newInput = input.val(parseInt(inputValue) - 1);
      $("#currentSelection").attr("data-quantity", newInput.val());
      updateLinks();
    }
  });
});
/* =============================================
  		ADD TO CART FB PIXEL
================================================ */
jQuery("#AddToCart-button").click(function() {
  	let ID = "";
    let characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    for ( var i = 0; i < 12; i++ ) {
      ID += characters.charAt(Math.floor(Math.random() * 36));
    }
  
	var productTitle = $('.product-single__title').text();
  	var prodPrice = $('#ProductPrice-product-template').text().trim().replace("$", "");
  	var contentName = `${productTitle}`;
  	
  	var GrpId =  $('#ProdBundle').data('vid');
  	var GrpTitle =  $('#ProdBundle').data('vtitle');
  	var GrpPrice =  $('#ProdBundle').data('vprice').replace("$","");
  	var GrpType =  $('#ProdBundle').data('vtype');
  	var tvbundle = $('#ProdBundle').data('tvbundle');
	//if(variantTitle !== 'Default Title') contentName += ` - ${variantTitle}`;
  	var event_ID = '0aba-prod-' +ID+"-"+ new Date().getTime();
	var event_bundle_ID = '0abe-bundle-'+ID +"-"+ new Date().getTime();

	// FB Pixel
	var fbqObj = {
		content_name: contentName,
		content_category: meta.product.type,
		content_ids: [meta.product.id],
		content_type: 'product_group',
		value: prodPrice,
		num_items: 1,
		currency: 'AUD'
	};
  if(fbq) fbq('track', 'AddToCart', fbqObj, {eventID: event_ID});
	
    if(GrpTitle){
      // FB Pixel for groupsell selected variant
      var fbqGrp = {
          content_name : GrpTitle,
          content_category: GrpType,
          content_ids: GrpId,
          content_type: 'product_group',
          value: GrpPrice,
          num_items: 1,
          currency: 'AUD'
      };
      fbq('track', 'AddToCart-bundle', fbqGrp, {eventID: event_bundle_ID});
    }
  });
/* end of FB Pixel */

$('.template-product .carousel-wrap .carousel-imgs').slick({
    loop: true,
    margin: 11,  
    dots: false,  
    responsiveClass: true,
    autoHeight: true,    
    nav: true,
    navText: [
      '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" width="512px" height="512px" viewBox="0 0 451.846 451.847" style="enable-background:new 0 0 451.846 451.847;" xml:space="preserve"><g transform="matrix(-1 -1.22465e-16 1.22465e-16 -1 451.846 451.847)"><g><path d="M345.441,248.292L151.154,442.573c-12.359,12.365-32.397,12.365-44.75,0c-12.354-12.354-12.354-32.391,0-44.744   L278.318,225.92L106.409,54.017c-12.354-12.359-12.354-32.394,0-44.748c12.354-12.359,32.391-12.359,44.75,0l194.287,194.284   c6.177,6.18,9.262,14.271,9.262,22.366C354.708,234.018,351.617,242.115,345.441,248.292z" data-original="#000000" class="active-path" fill="#000000"/></g></g> </svg>',
      '<svg enable-background="new 0 0 451.846 451.847" version="1.1" viewBox="0 0 451.85 451.85" xml:space="preserve" xmlns="http://www.w3.org/2000/svg"><path d="m345.44 248.29-194.29 194.28c-12.359 12.365-32.397 12.365-44.75 0-12.354-12.354-12.354-32.391 0-44.744l171.91-171.91-171.91-171.9c-12.354-12.359-12.354-32.394 0-44.748 12.354-12.359 32.391-12.359 44.75 0l194.29 194.28c6.177 6.18 9.262 14.271 9.262 22.366 0 8.099-3.091 16.196-9.267 22.373z"/></svg>'
    ],
    autoplay: false,
    autoplayHoverPause: true,
    responsive: {
      0: {
        items: 1,
        //center:true,
        //stagePadding:30,
        nav: true
      },
      767: {
        items: 1
      },
      1000: {
        items: 1
      }
    }
  });

/* =============================================
  		RELOAD PAGE ON VARIANT SELECT
================================================ */
jQuery( document ).ready(function($) {
  $('.product-form__variants2').bind('change', function () { // bind change event to select
        var purl = $('.product-form__variants2').attr('data-url');
        var url = $(this).val(); // get selected value
        var newurl = purl+'?variant='+url;
        if (newurl != '') { // require a URL
            window.location = newurl; // redirect
        }
        return false;
    });
});
/* =============================================
  		PROMO CODE DROPDOWN
================================================ */

jQuery(document).on('click', '.v_headWrap', function(){
  jQuery(this).toggleClass('opened');
  jQuery(this).next('.v_bodyWrap').slideToggle();
});
 

jQuery(document).on('click', '.v_codeRow', function(){
  if(!jQuery(this).hasClass('codeClicked')){
    var THIS = jQuery(this);
    var code = jQuery(this).attr('data-code');
    jQuery(this).addClass('codeClicked');
    console.log('test');
    copyToClipboard(code, function(){
      console.log('copy code');
      $('.v_copiedMsg').hide();
      THIS.find('.v_copiedMsg').slideDown('fast').css('display', 'flex');
      var d = setTimeout(function(){
        THIS.find('.v_copiedMsg').slideUp('fast');
        THIS.removeClass('codeClicked');
      },5000);
    });
  }
});

  function copyToClipboard(code, cb){
    console.log('copy');
    var input = document.createElement("input");
    input.setAttribute("value", code);
    input.setAttribute('readonly', '');
    input.style.position = 'absolute';
    input.style.left = '-9999px';
    document.body.appendChild(input);
    input.select();
    //for mobile devices this is mandatory
    input.setSelectionRange(0, 99999);
    document.execCommand("copy");
    document.body.removeChild(input);
    cb();
  }